export default "__VITE_ASSET__qQ_Qg2UT__"